import {QuestionnaireTypeModel} from "../../model";

export const urls = {
  home: "/quiz/",
  list: "/quiz/ques-types",
}

export const ListBreadcrumb = [
  {
    label: "Quiz",
    url: urls.home
  },
  {
    label: "Questionnaire Type",
    url: "#"
  }
];


export const CreateBreadcrumb = [
  {
    label: "Quiz",
    url: urls.home
  },
  {
    label: "Questionnaire Type",
    url: urls.list
  },
  {
    label: "Create",
    url: '#'
  }
];

export const EditBreadcrumb = [
  {
    label: "Quiz",
    url: urls.home
  },
  {
    label: "Questionnaire Type",
    url: urls.list
  },
  {
    label: "Edit",
    url: '#'
  }
];

export interface IState {
  id: number;
  form: QuestionnaireTypeModel;
}